import { LocalStorageKeys } from '@/types';
export var PendingDeepLinkStorageKey = 'pendingDeepLink';
export var NavigationFailureTtl = 30 * 60 * 1000;
export var getSessionStorage = function () {
    if (typeof window === 'undefined') {
        return null;
    }
    try {
        return window.sessionStorage;
    }
    catch (e) {
        return null;
    }
};
export var savePendingNavigation = function (value) {
    var storage = getSessionStorage();
    if (!storage) {
        return;
    }
    storage.removeItem(LocalStorageKeys.RedirectUrl);
    storage.setItem(PendingDeepLinkStorageKey, value);
};
export var savePostLoginNavigation = function (value) {
    var storage = getSessionStorage();
    if (!storage) {
        return;
    }
    storage.removeItem(PendingDeepLinkStorageKey);
    storage.setItem(LocalStorageKeys.RedirectUrl, value);
};
export var discardPendingNavigation = function () {
    var _a;
    (_a = getSessionStorage()) === null || _a === void 0 ? void 0 : _a.removeItem(PendingDeepLinkStorageKey);
};
export var discardPostLoginNavigation = function () {
    var _a;
    (_a = getSessionStorage()) === null || _a === void 0 ? void 0 : _a.removeItem(LocalStorageKeys.RedirectUrl);
};
export var discardNavigation = function () {
    var storage = getSessionStorage();
    if (!storage) {
        return;
    }
    storage.removeItem(PendingDeepLinkStorageKey);
    storage.removeItem(LocalStorageKeys.RedirectUrl);
};
var isNavigationFailureReason = function (value) {
    return value === 'target-company-inaccessible' || value === 'initialization-failed';
};
export var saveNavigationFailure = function (reason, targetUrl) {
    var storage = getSessionStorage();
    if (!storage) {
        return;
    }
    storage.setItem(LocalStorageKeys.RedirectLoopStopKey, JSON.stringify({
        reason: reason,
        targetUrl: targetUrl,
        createdAt: Date.now()
    }));
};
export var getNavigationFailure = function (now) {
    if (now === void 0) { now = Date.now(); }
    var storage = getSessionStorage();
    var value = storage === null || storage === void 0 ? void 0 : storage.getItem(LocalStorageKeys.RedirectLoopStopKey);
    if (!value) {
        return null;
    }
    // 旧形式のフラグは原因不明として安全側に扱う
    if (value === 'on') {
        return {
            reason: 'initialization-failed',
            targetUrl: '',
            createdAt: 0
        };
    }
    try {
        var record = JSON.parse(value);
        if (!isNavigationFailureReason(record.reason) ||
            typeof record.targetUrl !== 'string' ||
            !record.targetUrl ||
            typeof record.createdAt !== 'number' ||
            !Number.isFinite(record.createdAt) ||
            record.createdAt > now ||
            now - record.createdAt > NavigationFailureTtl) {
            storage === null || storage === void 0 ? void 0 : storage.removeItem(LocalStorageKeys.RedirectLoopStopKey);
            return null;
        }
        return {
            reason: record.reason,
            targetUrl: record.targetUrl,
            createdAt: record.createdAt
        };
    }
    catch (e) {
        storage === null || storage === void 0 ? void 0 : storage.removeItem(LocalStorageKeys.RedirectLoopStopKey);
        return null;
    }
};
export var clearNavigationFailure = function () {
    var _a;
    (_a = getSessionStorage()) === null || _a === void 0 ? void 0 : _a.removeItem(LocalStorageKeys.RedirectLoopStopKey);
};
